import { useRouteMatch } from 'react-router-dom';

// Only hide where map is visible
export const useFooterStatus = (): boolean => {
  const match = useRouteMatch(['/explore/diseases/:diseaseId/outbreaks', '/explore/countries']);

  return !match?.isExact;
};
